import { c as _c } from "react/compiler-runtime";
import { memo, type PropsWithChildren } from 'react';
interface MobileCardRowProps {
  label: string;
}
const MobileCardRow = t0 => {
  const $ = _c(5);
  const {
    label,
    children
  } = t0;
  let t1;
  if ($[0] !== label) {
    t1 = <span className="text-3xs text-secondary-foreground">{label}</span>;
    $[0] = label;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children || $[3] !== t1) {
    t2 = <div className="flex w-full items-center justify-between">{t1}{children}</div>;
    $[2] = children;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
export default memo(MobileCardRow);